import { call, sync } from "vuex-pathify"

export default {
    computed: {
        currentClient: sync('auth/client'),

        isLoggedIn() {
            return this.currentClient && this.currentClient.id ? true : false
        },
    },

    methods: {
        loadClients: call('clients/loadClients'),
    },
}
